module.exports = __webpack_public_path__ + "assets/img/home-pazq.5f7e7627.png";